import Vue from 'vue'
import App from './App.vue'
import router from './router'
//引入iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
//引入axios
import axios from 'axios'
axios.defaults.baseURL = 'https://api.smallTea.xiaoxxx.cn';
// axios.defaults.baseURL = 'http://test.api.smallTea.xiaoxxx.cn';

//引入rem
import rem from './js/rem'
// rem()
//引入fastclick
import FastClick from 'fastclick'
FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.use(ViewUI);
Vue.prototype.$axios = axios



new Vue({
  router,
  // mode: 'history',
  render: h => h(App)
}).$mount('#app')
